import type { AppDefinition } from '../../types/apps';

export const NotificationsAppDefinition: AppDefinition = {
  appId: 'notifications',
  name: 'Notifications',
  version: '1.0.0',
  description: 'Real-time notifications from background agents. Reply to keep conversations going.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Bell',
    phosphorWeight: 'duotone',
    color: '#f59e0b',
  },
  component: 'NotificationsApp',
  entityTypes: [],
  requiresProps: false,
  requiresEntity: false,
};
